// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"aaeb6cd1","106":"0aa43e5e","142":"c2f8453b","213":"e85d5df0","274":"889377b4","476":"073f22b3","587":"4290d9ac","798":"0cdc5ff0","840":"6bf458db","966":"fa6f8cfd"}[chunkId] + ".chunk.js";
};